module.exports = __webpack_public_path__ + "static/media/PER.b090abe8.png";